import { TableauDashboard } from '@/types/TableauDashboard';
import { Service } from './api';
import { Document } from '@/types/v2/Document';

// Type interfaces
export interface ReportingType {
  name: string;
  description?: string;
}

export interface ReportingTableauType {
  tableauTypeId: number;
  tableauTypeName: string;
  reportingType: string;
}

export interface ReportingDocumentType {
  documentTypeId: number;
  documentTypeName: string;
  reportingType: string;
}

export interface CreateReportingDashboardRequest {
  name: string;
  dashboardUrl: string;
  tableauTypeId: number;
  reportingType: string;
}

export interface UploadDocumentRequest {
  domain: string;
  type: string;
  displayName: string;
  fileName: string;
  document: File;
  reportingType: string;
}

class ReportingService extends Service {

  async getReportingTypes(): Promise<ReportingType[]> {
    return await this.get<ReportingType[]>('/v2/reporting/types').then(this.handleResponse);
  }
  async getTableauTypes(): Promise<ReportingTableauType[]> {
    return await this.get<ReportingTableauType[]>('/v2/reporting/tableau-types').then(this.handleResponse);
  }

  async getDocumentTypes(): Promise<ReportingDocumentType[]> {
    return await this.get<ReportingDocumentType[]>('/v2/reporting/document-types').then(this.handleResponse);
  }
  async getReportingTableauDashboards(): Promise<TableauDashboard[]> {
    return await this.get<TableauDashboard[]>('/v2/reporting/tableau-dashboards').then(this.handleResponse);
  }

  async getReportingDocuments(): Promise<Document[]> {
    return await this.get<Document[]>('/v2/reporting/documents').then(this.handleResponse);
  }

  async createReportingTableauDashboard(request: CreateReportingDashboardRequest): Promise<void> {
    return await this.post<void>('/v2/reporting/tableau-dashboards', request).then(this.handleResponse);
  }

  async createReportingDocument(request: UploadDocumentRequest): Promise<void> {
    // This would need to be implemented based on your backend API
    const formData = new FormData();
    formData.append('file', request.document);
    formData.append('request', JSON.stringify({
      domain: request.domain,
      type: request.type,
      displayName: request.displayName,
      fileName: request.fileName,
      reportingType: request.reportingType,
    }));

    return await this.post<void>('/v2/reporting/documents', formData).then(this.handleResponse);
  }
}

export const reportingService = new ReportingService();
